import giftIcon from '../../../../../../assets/icons/finnkino/gift.svg'
import popcornIcon from '../../../../../../assets/icons/finnkino/Popcorn.svg'
import ticketIcon from '../../../../../../assets/icons/finnkino/Ticket.svg'
import type { PromoType } from '../types'

export function getIconByPromoType(type?: PromoType): { src: string; alt: string } {
    switch (type) {
        case 'f&b':
            return { src: popcornIcon, alt: 'Food and Beverage' }
        case 'ticketing':
            return { src: ticketIcon, alt: 'Ticketing' }
        case 'generic':
        default:
            return { src: giftIcon, alt: 'Generic' }
    }
}
